import { getStore } from '../store/store';

export default function getStaticSearchScope() {
    return getStore().staticSearchScope;
}
